import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Typography from "../UI/Typography/Typography"
import Link from "../UI/Link/Link"
import Image from "../UI/Image/Image"
import useImage from "../../hooks/useImage"
import Input from "../UI/Input/Input"
import Select from "../UI/Input/Select"
import {
  jobFamily,
  countryList,
  searchJob,
} from "../../constants/label.constants"
import Button from "../UI/Button/Button"
import { imageConstants } from "../../constants/image.constants"
import Video from "../UI/Video/Video"
import { get } from "../../helpers/utils"
import { gaFilterClick, searchJobGtm } from "../../constants/gtm.constants"
const { countryJobLocation } = require("../../service/CountryJobLocation")

const ImageHeroBanner = props => {
  const {
    description,
    heading,
    subHeading,
    link,
    label,
    style,
    backLink,
    underlineText,
    isJobSearch,
    images,
    video,
    countryCode,
    countryData,
    variant,
    languageLinkCollection,
    jobFamilyFilter
  } = props
  //const countryOptions = countryData ? countryData?.Country : countryList
  const languageTab = get(languageLinkCollection, "items", [])
  const { altText, foregroundImg, backgroundImg } = useImage(images)
  let queryParams = ""
  const [searchTerm, setSearchTerm] = useState("")
  const [LocationFilter, setLocationFilter] = useState("")
  const [JobFilter, setJobFilter] = useState("")
  const [countrywiseJobLocation, setCountrywiseJobLocation] = useState(null)

  useEffect(() => {
    if (isJobSearch) {
      const filter = jobFamily.find(item => item.label === jobFamilyFilter)
      if (filter) {
        setJobFilter(filter.value)
      }
    }
    if (countryCode) {
      (async () => {
        let data = await countryJobLocation(countryCode)
        let newobj = countryCode.length < 2 ? { label: "Select location", value: countryCode } : { label: "Select location", value: "" }
        data.unshift(newobj);
        setCountrywiseJobLocation(data)
      })();
    }
  }, [])

  const handleSearch = e => {
    setSearchTerm(e.target.value)
  }

  const handleLocationFilterChange = e => {
    setLocationFilter(e.target.value)
  }

  const handleJobFilterChange = e => {
    setJobFilter(e.target.value)
  }
  const countryOptions = countryCode ? countrywiseJobLocation : countryList
  const countryCodeArr = countryData?.Country.slice(0, 1)
  let countryCd = ""
  countryCodeArr?.map((item, index) => (countryCd = item?.value))
  const handleSubmit = () => {
    queryParams =
      `/careers/jobs?term=${searchTerm}` +
      `${countryData
        ? LocationFilter === ""
          ? `&countrycode=${countryCd}`
          : `&locationid=${LocationFilter}`
        : LocationFilter === ""
          ? ``
          : `&countrycode=${LocationFilter}`
      }` +
      `${JobFilter === "" ? "" : `&jobFamily=${JobFilter}`}`
    history.pushState({}, "", queryParams)
    if (typeof window !== "undefined") {
      //data layer push
      if (window?.dataLayer) {
        searchJobGtm.GAeventLabel = searchTerm
        searchJobGtm.GAeventCategory = "searchJob"
        window.dataLayer.push({ ...searchJobGtm })
      }
    }
    location.reload()
  }

  const {
    bannerContent,
    bannerForm,
    imageResponsive,
    txtcontent,
    textSubHead,
    gradBox,
    txtHead,
    txtDesc,
    subTitle,
    heroLink,
    backBtn,
    imgParent,
    imgBg,
    imgWrapper,
    eventMenu,
    topNav,
    subTitletext,
    heroLinkWrapper,
    selectWrap,
    inputWrap,
    buttonWrapper,
    foregroundImgWrapper,
  } = style

  const handleKeyDown = e => {
    if (e.keyCode === 13) {
      handleSubmit()
    }
  }

  // if condition added to call image at build time for homepage to improve LCP
  function renderBannerImg() {
    if (heading && heading.toUpperCase() === "SUSTAINABILITY") {
      return (
        <Image
          src={images?.imageDesktop?.url}
          alt={images?.imageDesktop?.altText || images?.altText}
          className={imageResponsive}
        />
      )
    } else if (foregroundImg) {
      return (
        <Image
          contentfulImage={foregroundImg}
          className={imageResponsive}
          alt={altText}
        />
      )
    }

  }
  return (
    <div className={bannerContent}>
      <div className={foregroundImgWrapper}>
        {gradBox && <div className={gradBox}></div>}
        {renderBannerImg()}
      </div>
      <div className={imgParent}>
        <div className={imgBg}></div>
        <div className={imgWrapper}>
          {backgroundImg && (
            <Image
              contentfulImage={backgroundImg}
              className={imageResponsive}
            />
          )}
        </div>
      </div>
      <div className={style?.bannerTextWrapWidth}>
        {video && (
          <div>
            <Video {...video} />
          </div>
        )}

        {backLink && (
          <div className={backBtn}>
            <Link {...backLink} />
          </div>
        )}
        {underlineText ||
          (heading && (
            <div className={txtcontent}>
              {underlineText && (
                <div className={subTitletext}>{underlineText}</div>
              )}
              {heading && <Typography className={txtHead} content={heading} />}
              {subHeading && <div className={textSubHead}>{heading}</div>}
            </div>
          ))}
        {description && (
          <div className={txtDesc}>
            {description && (
              <Typography className={subTitle} content={description} />
            )}
          </div>
        )}
        {isJobSearch && (
          <div className={bannerForm}>
            <div className={inputWrap} data-testid="search-input">
              <Input
                type="text"
                placeholder={searchJob}
                value={searchTerm}
                onChange={handleSearch}
                variant={variant}
                onKeyDown={handleKeyDown}
              />
              <Button className={buttonWrapper} onClick={handleSubmit}>
                <Image contentfulImage={imageConstants?.searchCareersOrange} />
              </Button>
            </div>
            <div className={selectWrap}>
              <Select
                name="LocationFilter"
                onChange={handleLocationFilterChange}
                options={countryOptions}
                variant={variant}
                gaEventClass={gaFilterClick}
                onKeyDown={handleKeyDown}
              />
              <Select
                name="JobFilter"
                onChange={handleJobFilterChange}
                options={jobFamily}
                variant={variant}
                selectedValue={JobFilter}
                gaEventClass={gaFilterClick}
                onKeyDown={handleKeyDown}
              />
            </div>
          </div>
        )}
        {link && (
          <div className={heroLinkWrapper}>
            <Link
              {...link}
              gaEventClass={`${eventMenu || ""} ${link?.gaEventClass}`}
              dataActionDetailPrefix={topNav}
              className={heroLink}
            >
              {link?.label != "Back to top" && link?.label}
              {link?.image && <Image src={link?.image?.url}/>}
            </Link>
          </div>
        )}
        <div>
          {languageLinkCollection &&
            languageTab?.map((item, idx) => {
              return (
                <div key={idx}>
                  <Link
                    url={item?.url}
                    className={
                      typeof window !== "undefined" &&
                        window.location?.pathname === item.url?.url
                        ? `black`
                        : `white`
                    }
                    gaEventClass={item?.gaEventClass}
                  >
                    {item?.label}
                  </Link>
                </div>
              )
            })}
        </div>
      </div>
    </div>
  )
}

ImageHeroBanner.propTypes = {
  description: PropTypes.string,
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  images: PropTypes.object,
  video: PropTypes.object,
  underlineText: PropTypes.string,
  buttonText: PropTypes.string,
  link: PropTypes.object,
  label: PropTypes.string,
  variant: PropTypes.string,
  backBtn: PropTypes.object,
  backLink: PropTypes.object,
  style: PropTypes.object,
  isJobSearch: PropTypes.bool,
  countryCode: PropTypes.any,
  countryData: PropTypes.object,
  languageLinkCollection: PropTypes.object,
  jobFamilyFilter: PropTypes.string
}

export default ImageHeroBanner
